(function () {
  window.address = {};

  var addresses = [];
  var translations = [];
  var newlyAddedAddress = false;

  selectAddresses = function(dataAddresses, dataTranslations, data, term, addressId){
    $.each(dataTranslations, function (i, ob) {
      $.each(ob, function(j, val){
        var added=false;
        $.map(data.results, function (elementOfArray, indexInArray) {
          if (elementOfArray.id == val.address_id) {
            added = true;
          }
        });
        if (val.address_id != addressId){
          if (val.place_name != null) {
            if (val.place_name.toLowerCase().indexOf(term) >= 0) {
              var valAddress = $.grep(dataAddresses, function(e) { return e.id == val.address_id });
              if(!added){
                data.results.push(valAddress[0]);
              }
            }
          } else {
            val = $.grep(dataAddresses, function(e) { return e.id == val.address_id });
            if (val[0].address_1 != null && !added){
              if (val[0].address_1.toLowerCase().indexOf(term) >= 0) {
                data.results.push(val[0]);
              }
            } else
              if (val[0].zip != null && !added){
                if (val[0].zip.indexOf(term) >= 0 ) {
                  data.results.push(val[0]);
                }
              } else if (val[0].city != null && !added){
                if (val[0].city.toLowerCase().indexOf(term) >= 0) {
                  data.results.push(val[0]);
                }
              }
          }
        }
      });
    });
  },

  formatAddress = function(item, highlightTemplate){
    var addressFields;
    var formattedFields;
    var separator = ', ';
    addressFields = [item.address_1, item.address_2, item.zip];
    addressFields = $.grep(addressFields, function(n){ return(n) });
    var place_name = item.place_name;
    var address_city = item.city === null ? '' : item.city;
    var place_name_blank = (place_name === null || place_name === '');

    formattedFields = (place_name_blank ? '' : place_name) +
      (((addressFields.length > 0) && !place_name_blank) ? separator : '') +
      "<span id='addressDetails' style='color: #A6A6A6; '>"  + addressFields.join(separator) + ' ' + address_city + "</span>";
    return highlightTemplate ? ("[✓] " + formattedFields) : formattedFields;
  },


  /**
   * Initialize the delete address over a delete address container.
   * */
  initDeleteAddress = function (container) {
    var addressPlaceName = container.find('#address_place_name');
    var form             = container.find('form');
    var addressesPath    = form.attr('data-AddressesPath');
    var addressId        = form.attr('data-AddressId');

    if (addresses.length === 0) {
      $.getJSON(addressesPath)
        .done(function (data) {
          addresses    = jQuery.parseJSON(data.addresses);
          translations = jQuery.parseJSON(data.translations);
        });
    }

    addressPlaceName.select2({
      placeholder: $('[data-addressId]').data("select-an-address"),
      dropdownCssClass: "delete-address",
      query: function (query) {
        var term = query.term;
        if (term == "") {
          var data = {
            results: addresses.filter(function (address){
              return address.id.toString() !== addressId;
            })
          };
        } else {
          var data = {results: []};
          selectAddresses(addresses, translations, data, term, addressId)
        }
        query.callback(data);
      },
      formatResult: function (item) {
        return formatAddress(item, false);
      },
      formatSelection: function (item) {
        $('#address_id').val(item.id);
        return formatAddress(item, false);
      }

    })
  },

  showAddress = function (address) {
    $('.select2-chosen').html(formatAddress(address, false));
    $('#address_address_1').text((address.address_1 == null) ? ('') : address.address_1);
    $('#address_place_name').text((address.place_name == null) ? ('') : address.place_name);
    if (address.address_2) {
      $('#address_address_2').text(address.address_2).show();
    } else {
      $('#address_address_2').hide();
    }
    $('#address_zip').text((address.zip == null) ? '' : address.zip);
    $('#address_city').text((address.city == null) ? '' : address.city);

    if (address.lat != null && address.lng != null){
      var location = {lat: address.lat, lng: address.lng};

      mapContainer.trigger('map.clear-markers')
        .trigger('map.add-marker', location);

      setTimeout(function () {
        mapContainer.trigger('map.resize')
          .trigger('map.set-center', location);
        mapContainer.data('map').setZoom(15);
      }, 300);

      $('.read-address').show();
    }
    else {
      $('.read-address').hide();
    }
  },

  searchAddress = function(idKey, myArray) {
    for (var i=0; i < myArray.length; i++) {
      if (myArray[i].id == idKey) {
        return myArray[i];
      }
    }
  },


  initMessageAddress = function (container) {
    var messagePlaceName     = container.find("[data-addressId]");
    var idSelectedInTemplate = messagePlaceName.attr('data-idSelectedInTemplate');
    var newAddressPath       = container.data('new-address-path');
    var messageAddressesPath = container.data('addresses-path');

    if (addresses.length == 0) {
      $.getJSON(messageAddressesPath)
        .done(function (data) {
          addresses = jQuery.parseJSON(data.addresses);
          translations = jQuery.parseJSON(data.translations);
        })
        .done(function(data) {
          var address_id = container.find("[data-addressId]");
          var address;
          if (address_id[0].value !== "") {
            address = searchAddress(address_id[0].value, addresses);
            showAddress(address);
          }
        });
    }

    messagePlaceName.select2({
      placeholder: $('[data-addressId]').data("select-an-address"),
      dropdownCssClass: "message-address",
      allowClear: true,
      // This function option is only needed for the clearing X button to be shown -
      // it doesn't actually seem to do anything, but without a function here,
      // the X button will not be shown
      initSelection: function(element, callback) {
        var data = [];
        data.push({id: element.val(), text: element.val()});
        callback(data);
      },
      query: function (query) {

        if (newlyAddedAddress){
          $.getJSON(messageAddressesPath)
            .done(function (data) {
              addresses = jQuery.parseJSON(data.addresses);
              translations = jQuery.parseJSON(data.translations);
            });
        }

        var term = query.term;
        if (term == "") {
          var data = {results: addresses.slice()}; // slice() copies as new instance
        } else {
          var data = {results: []};
          selectAddresses(addresses, translations, data, term, '')
        }

        var newItem = {};
        newItem.text = "<li>" + $("<a>", {text: 'Add new'}) + "</li>";
        newItem.id = 'newitem';
        data.results.push(newItem);
        query.callback(data);
      },
      formatResult: function (item) {
        if (item.id == 'newitem') {
          return $('[data-addressId]').data("add-new-address");
        } else if (item.id == idSelectedInTemplate) {
          return formatAddress(item, true);
        } else {
          return formatAddress(item, false);
        }
      },
      formatSelection: function (item) {
        if (item.id == 'newitem') {
          window.address.create(newAddressPath).done(function (address) {
            $("[data-addressId]")[0].value = address.id;
            newlyAddedAddress = true;
            showAddress(address);
          });
        } else {
          newlyAddedAddress = false;
          showAddress(item);
        }
        return false;
      }
    })
    // when clearing with the little x clear button, hide the shown address and map
    messagePlaceName.on("select2-clearing", function(e) {
      // also empty form field
      $("[data-addressId]").val("");
      $('.read-address').hide();
    })
    GMap().init(mapContainer);
  };

  $(document).ready(function () {
    if ($('.place-name').length > 0) {
      var selectView;
      mapContainer = $('#address-map-canvas');

      if ($('#new_message_form').length > 0) {
        selectView = $('#new_message_form');
      }
      else {
        selectView = ($("form[id^='edit_convention_']").length == 0 ? $('#new_convention') : $("form[id^='edit_convention_']"));

        if(selectView.length == 0) {
          selectView = ($("form[id^='edit_page_']").length == 0 ? $('#new_page') : $("form[id^='edit_page_']"))
        }
      }

      if (selectView.length > 0){
        initMessageAddress(selectView);
      }
    }
  });

  window.address.deleteAutoComplete = initDeleteAddress;
  window.address.initMap = initMap;
})();

/**
 * New address dialog module
 * */

var addressFunctions = (function () {
  return {
    addInputError: function (input, message) {
      input.after('<span class="error">' + message + '</span>');
      input.parent().addClass('field_with_errors');
    },
    removeAllErrors: function (form) {
      form.find('.error').remove();
      form.find('.field_with_errors').removeClass('field_with_errors');
    },
    submitAddress: function (form) {
      console.log($('#address_color', form).val());
      return $.ajax({
        url: form.attr('action'),
        type: form.attr('method'),
        data: form.serialize(),
        dataType: 'json'
      });
    },

    bindDialog: function (dialog, deferred) {
      var newAddressForm = dialog.find('form.address');
      var fieldWrapper   = newAddressForm.attr('data-AddressFieldWrapper');
      var formButtons    = newAddressForm.find('.buttons');
      var submitButton   = formButtons.find('input');

      newAddressForm.on('submit', function () {
        submitButton.attr('disable', 'disable');

        addressFunctions.removeAllErrors(newAddressForm);

        addressFunctions.submitAddress(newAddressForm)
          .done(function (data) {
            dialog.dialog('close');
            deferred.resolve(data);
          })
          .fail(function (xhr, status, error) {
            var errors = $.parseJSON(xhr.responseText);

            for (var key in errors) {
              var value = errors[key];
              var input;

              input = newAddressForm.find('[name="' + fieldWrapper + '[' + key + ']"]');

              if(input.size() == 0){
                input = newAddressForm.find('[name="' + fieldWrapper + '[translations_attributes][][' + key + ']"]');
              }

              addressFunctions.addInputError(input, value);
            }
          })
          .always(function () {
            submitButton.removeAttr('disable');

          });

        return false;
      });
    }
  };
})();

(function () {
  var dialog;
  /**
   * Initialize the map and geocoding features
   * */

  window.address.create = function (newAddressPath) {
    var deferred = $.Deferred();

    if (dialog) {
      dialog.dialog('open');
      dialog.find("form").find('div.translated-field').show();
      return deferred.promise();
    }

    $.get(newAddressPath)
      .done(function (data) {
        var windowWidth = $(window).width();
        var container = $('<div>').append(data);

        $(document.body).append(container);
        container.find("form").find('div.translated-field').show();
        var form;

        dialog = container.dialog({
          modal: true,
          title: $('.address-translations').data("new-address"),
          width: windowWidth - (windowWidth * 40) / 100,
          minWidth: 750,
          position: ['center', 100],
          close: function () {
            form.get(0).reset();
            form.find('#address-map').hide();
            addressFunctions.removeAllErrors(form);
          },
          buttons: [
            {
              text: $('.address-translations').data("save"),
              click: function() {
                form.trigger('submit');
              }
            },
            {
              text: $('.address-translations').data("cancel"),
              click: function() {
                form.get(0).reset();
                addressFunctions.removeAllErrors(form);
                form.find('#address-map').hide();
                dialog.dialog('close');
              }
            }
          ]
        });
        form = dialog.find('form');
        window.address.initMap(form);
        $('#clear-address').addClass('ui-state-focus');

        addressFunctions.bindDialog(dialog, deferred);
      });

    return deferred.promise();
  };
})();

/**
 * Edit address module
 * */

(function () {
  var dialog;

  window.address.edit = function (editPath) {
    var deferred = $.Deferred();

    if (dialog) {
      dialog.dialog('open');
      $('#clear-address').addClass('ui-state-focus');
      return;
    }

    $.get(editPath)
      .done(function (data) {
        var windowWidth = $(window).width();
        var container = $('<div>').append(data);

        $(document.body).append(container);
        container.find("form").find('div.translated-field').show();

        var dialog = container.dialog({
          modal: true,
          title: $('.address-translations').data("edit-address"),
          width: windowWidth - (windowWidth * 50) / 100,
          minWidth: 750,
          position: ['center', 100],
          buttons: [
            {
              text: $('.address-translations').data("save"),
              click: function() {
                dialog.find('form').trigger('submit');
              }
            },
            {
              text: $('.address-translations').data("cancel"),
              click: function() {
                dialog.find('form').resetForm();
                dialog.dialog('close');
              }
            }
          ]
        });

        editForm = dialog.find('form');
        window.address.initMap(editForm);
        addressFunctions.bindDialog(dialog, deferred);
      })
      .fail(function () {
        deferred.reject();
      });
    return deferred.promise();
  };
})();

/**
 * Delete address module
 * */

(function () {
  function submitDelete(form) {
    return $.ajax({
      url: form.attr('action'),
      type: form.attr('method'),
      data: form.serialize()
    });
  }

  function bindDeleteDialog(dialog, deferred) {
    var formButtons  = dialog.find('.buttons');
    var submitButton = formButtons.find('input');
    var deleteForm   = dialog.find('form');

    deleteForm.on('submit', function () {
      submitButton.attr('disable', 'disable');
      var notFoundError = deleteForm.find('.error').hide();

      submitDelete(deleteForm)
        .done(function (data) {
          dialog.dialog('close');
          deferred.resolve(data);
        })
        .fail(function (xhr, status, error) {
          if (xhr.status == 200) {
            dialog.dialog('close');
            deferred.resolve(data);
          }
          if (xhr.status == 404) {
            notFoundError.show();
          }

        })
        .always(function () {
          submitButton.removeAttr('disable');
        });

      return false;
    });
  }

  window.address.dodelete = function (deletePath, callbackCancel) {
    var deferred = $.Deferred();

    $.get(deletePath)
      .done(function (data) {
        var windowWidth = $(window).width();
        var container = $('<div>').append(data);

        $(document.body).append(container);

        var dialog = container.dialog({
          modal: true,
          title: $('.address-translations').data("delete-address"),
          width: windowWidth - (windowWidth * 60) / 100,
          position: ['center', 100],
          close: function () {
            dialog.find('form').get(0).reset();
            $('#addressDetails').remove();
            dialog.dialog('destroy').remove();
          },
          buttons: [
            {
              text: $('.address-translations').data("save"),
              click: function () {
                dialog.find('form').trigger('submit');
              }
            },
            {
              text: $('.address-translations').data("cancel"),
              click: function () {
                dialog.find('form').get(0).reset();
                $('#address_id').val('');
                dialog.dialog('destroy').remove();
                return false;
              }
            }
          ]
        });

        window.address.deleteAutoComplete(dialog);
        bindDeleteDialog(dialog, deferred, callbackCancel);
      })
      .fail(function () {
        deferred.reject();
      });

    return deferred.promise();
  };
})();

(function () {
  /** Public **/

  $(document)
    .on('ready', function () {

      $('#address-map-canvas').each(function () {
        window.address.initMap($(this).closest('form'));
      })
    })

    .on('click', '[data-newAddress]', function () {
      var $this = $(this);
      window.address.create($this.attr('href'))
        .done(function () {
          window.location.reload();
        });

      return false;
    })

    .on('click', '[data-deleteAddress]', function () {
      window.all_payload_menu_drops[$(this).parents("ul").attr("id")].close();
      var $this = $(this);
      window.address.dodelete($this.attr('href'))
        .done(function () {
          window.location.reload();
        })
        .fail(function () {
          alert($this.attr('data-notFound'));
        });

      return false;
    })

    .on('click', '[data-editAddress]', function () {
      var $this = $(this);
      window.address.edit($this.attr('href'))
        .done(function () {
          window.location.reload();
        })
        .fail(function () {
          alert($this.attr('data-notFound'))
        });

      return false;
    })
})();
